import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Man better transport than Car",
  "description": "",
  "published": "2009-03-16T00:00:00.000Z",
  "redirect_from": ["/blog/man-better-transport-than-car/swizec/435"],
  "categories": "Dresden Dolls, funny, life, rant, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today was christmas except even better because all the gifts were either results of some serious impulse buying or something I've been meaning to waste money on for a while and finally cracked under the pressure of my own need for money wasting. I kid you not, nothing I got was paramount or even very important to the survival of ... anyone. Best kind of purchase you can make!`}</p>
    <p>{`After coming home from class I immediately checked the mailbox to confirm arrival of a package I'd been expecting except, lo and behold!, not only was there a note to come pick up something awesomer than boobs, but my new `}<a parentName="p" {...{
        "href": "http://www.dresdendolls.com/",
        "title": "The Dresden Dolls"
      }}>{`The Dresden Dolls`}</a>{` necktie. The delight was so great I took a few photos even though I don't usually like photographing myself.`}</p>
    <p>{`[`}{`gallery]`}</p>
    <p>{`And now we get to the part where I figure out that having a car is great, but only until you have some serious transporting to do.`}</p>
    <p>{`So I get to the post office, wait in line, talk to the friendly clerk blahblah. She brings forth an extremely small package and when I go "Wtf? O.o" she smiles and says "Oh there's something much bigger waiting for you in the backroom". At this point I get scared, since I don't think I ever actually thought about having to move the bloody whiteboard. I just imagined it on the wall, nothing aobut how it might get there.`}</p>
    <p>{`Naturally there was no way of getting the damned thing into mum's car. Sure it might potentially be able to sit inside and take a ride, but getting it in there was beyond a Herculean task, it was downright impossible. Cars simply don't have big enough orifices for these things. Darn.`}</p>
    <p>{`Off we go, whiteboard, all 18 kilo of it, resting dodgilly on my head with arms for balance and walking through town center ... at least it was late enough so I didn't get stared at too much. Although I did notice a kid driving by me at least four times on a bicycle, wonder why.`}</p>
    <p>{`Anyhow, I got home without incident, went back for the car and small package, then had to lug everything up into fourth storey without a lift. That's right, no lift, just narrow crooked steps. Yay. But it was all worth it, I now have a whiteboard covering most of the available wall space opposite the computer and that's really the best configuration I could ask for.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2009/03/img00197-300x225.jpg",
        "alt": "Fresh new whiteboard",
        "title": "img00197"
      }}></img></p>
    <p>{`For the record, I have yet to play with the damned thing. Sure it was fun installing it. Sure it was fun lugging it around. Sure it was somewhat interesting making several useless holes in the wall. But god damn it I want to play with this thing so much I might just go do my maths homework.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/087f11b0-5162-439a-93f0-62a58fd2cf7e/",
        "title": "Zemified by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=087f11b0-5162-439a-93f0-62a58fd2cf7e",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      